import React, { Component } from 'react'

import Options from "./Item"
import SelectTags from "./tag"

// 기본 데이터 요소
const defaultData = {
  isActive : false,
  isOpen: false,
  isMulti : false,
  title : "",
  selectItem : [],
  selectItemCount : 0
}

class SelectBox extends Component {
  constructor(props) {
    super(props);

    defaultData.title = this.props.title;

    this.state = {
      isActive : defaultData.isActive,
      isOpen: defaultData.isOpen,
      isMulti : defaultData.isMulti,
    }
  }

  componentDidMount() {
    // 셀렉트 옵션 박스 고정 여부
    this.props.isOpen && this.setState({ isActive : true, isOpen : true })
    // 멀티 셀렉트 기능 활성화 여부
    this.props.isMulti && this.setState({ isMulti : true })
    // 셀렉트 타이틀 문구
    if(!this.props.isMulti) {
      this.props.title ?
          this.setState({ title : this.props.title }) :
          this.setState({ title : this.props.OptionData[0].name })
    }
    let tt = [];
    let cc = defaultData.selectItemCount;
    let title = defaultData.title;
    if(this.props.currentData) {
      let temp = [];
      this.props.currentData.map((item, idx) => {
        let t = {};
        t.name = item;
        t.value = item;
        temp.push(t);
      });
      if(temp.length > 0)
        tt = temp;
      cc = tt.length;
      title = cc + " 개 선택 중";
    }
    defaultData.title = this.props.title;
    this.setState({
      title: title,
      selectItem: tt,
      selectItemCount: cc
    })
  }

  // 셀렉트 옵션 박스 토글 (셀렉트 옵션 박스 고정이 아닐 경우)
  toggleMenu = () => {
    !this.state.isOpen &&
    this.setState(prevActive => ({
      isActive : !prevActive.isActive
    }))
  }

  // 옵션 선택시 이벤트
  selectOption = (data) => {    
    this.state.isMulti ?
    this.multiDataProcess(data) :
    this.singleDataProcess(data)
  }

  // 싱글 셀렉트 박스 사용시 데이터 처리
  singleDataProcess = (data) => {
    this.setState({
      selectItem : data
    }, () => {
      this.setState({ 
        title : data.name, 
        isActive: false 
      })
    })
  }

  // 멀티 셀렉트 박스 사용시 데이터 처리
  multiDataProcess = (data) => {
    const key = data.value

    let chkStatus = 
    this.state.selectItem.findIndex(
      i => i.value === key
    )

    chkStatus === -1 ?
    this.addOption(data) : 
    this.removeOption(data)
  }

  // 선택한 옵션 데이터 추가 및 상태 변경
  addOption = (data) => {
    let outputText = ""
    let selectItem = this.state.selectItem

    if(data.children) {
      data.children.map((data2, idx) => {
        selectItem = selectItem.filter(f => f.name !== data2.name)
      })
    }

    selectItem.push(data)

    this.setState({
      selectItem : selectItem,
      selectItemCount : selectItem.length
    }, () => {
      outputText = this.state.selectItemCount > 0 ? this.state.selectItemCount + " 개 선택 중" : defaultData.title
      this.setState({ title : outputText })
      this.props.onAdd(event);
    })
    // onChange={this.facetCheckChangeEvent}
  }

  // 선택한 옵션 데이터 제거 및 상태 변경
  removeOption = (event, data) => {
    if(!data)
      return;
    const key = data.value
    let outputText = ""

    this.setState({
      selectItem : this.state.selectItem.filter( i => i.value !== key ),
      selectItemCount : this.state.selectItemCount - 1
    }, () => {
      outputText = this.state.selectItemCount > 0 ? this.state.selectItemCount + " 개 선택 중" : defaultData.title
      this.setState({ title : outputText })
      this.props.onRemove(event);
    })
  }

  render() {
    const { selectOption, removeOption } = this;

    return (
      <div className="form-input">
        <div className="mulity-custom-select">
          <div className="form-input">
            <button 
              type="button"
              className="btn-custom-select dropdown-small"
              onClick={ this.toggleMenu } >
              { this.state.title }
            </button>
          </div>
          {
            this.state.isActive &&
            (
              <div className="collapse show">
                {this.props.OptionData.length > 0 &&
                <div className="custom-select-list">
                  {
                    this.props.OptionData.map((data, idx) => {
                      return (
                        <Options
                            key={idx}
                            data={data}
                            inputName={this.props.name}
                            name={data.name}
                            value={data.value}
                            children={data.children}
                            SelectEvent={selectOption}
                        />
                      )
                    })
                  }
                </div>
                }
              </div>
            )
          }
        </div>
        {
          this.state.isMulti && (
            <SelectTags
              name={this.props.name}
              selectData={this.state.selectItem}
              RemoveEvent={removeOption}
            />
          )
        }
      </div>
    )
  }
}

export default SelectBox;
